import {
  SAVE_TOKEN,
  SAVE_MP_TOKEN,
  CLEAR_TOKEN,
  SAVE_ID,
  SAVE_DETAIL,
  SAVE_ROUTE,
  SELECT_PLAYER,
  CLEAR_PLAYER,
  WECHAT_TIP,
  VERIFY_CODE,
  VOTE_AD,
  COUNTDOWN_END,
  FOOTER_END,
  SHOW_POSTER,
  UPDATE_TIP,
  SHOW_MEAU,
  SHOW_SELECT,
  CLEAR_GROUP_PLAYER,
  SAVE_GROUP_ID,
  SAVE_VOTE_RULE,
  SAVE_GROUP_DATA,
  SAVE_REAL_GROUP_ID,
  SHOW_GROUP_SUB_VIEW,
  EXPAND_VOTE_RULE,
SET_LAST_VOTE_PLAYER_ID,
  SET_LAST_VOTE_PLAYER_IDS
} from './mutation-types'

const state = {
  token: '',
  mp_token: null,
  id: 0,
  currentGroupId:0,
  groupData:[],
  detail: null,
  from: {},
  to: {},
  groupIds:{},
  expand:true,
  playerIds: [],
  showTip: false,
  showCode: false,
  showVoteAd: false,
  showPoster: false,
  updateTip: false,
  showMeau:true,
  showSelect:true,
  realGroupId: 0,
  ruleMultiple:0,
  showGroupSubView:false,
  voteRule: {},
lastVotePlayerId: null,
  lastVotePlayerIds: []
}

const mutations = {
  [SAVE_TOKEN](state, token) {
    state.token = token
  },
  [SAVE_MP_TOKEN](state, token) {
    state.mp_token = token
  },
  [SHOW_MEAU](state,showMeau){
    state.showMeau = showMeau
  },
  [EXPAND_VOTE_RULE](state,expand){
    state.expand = expand
  },
  [SHOW_GROUP_SUB_VIEW](state,showGroupSubView){
    state.showGroupSubView = showGroupSubView
  },
  [SHOW_SELECT](state,showSelect){
    state.showSelect = showSelect
  },
  [CLEAR_TOKEN](state) {
    state.token = null
    state.mp_token = null
  },
  [SAVE_ID](state, id) {
    state.id = id
  },
  [SAVE_GROUP_ID](state,groupId){
    state.currentGroupId = groupId
  },
  [SAVE_REAL_GROUP_ID](state,groupId){
    state.realGroupId = groupId
  },
  [SAVE_GROUP_DATA](state,groupData){
    state.groupData = groupData
  },
  [SAVE_VOTE_RULE](state,voteRule){
    state.voteRule = voteRule
  },
  [SAVE_DETAIL](state, detail) {
    state.detail = detail
  },
  [SAVE_ROUTE](state, { from, to }) {
    state.from = from
    state.to = to
  },
  [SELECT_PLAYER](state, payload) {
    const { playerId, groupId, multiple, ruleType } = payload;

    // 统一处理：isSelect=true 表示选中，false 表示取消

    if (ruleType === 0) {
      // 无分组模式
      if (multiple) {
        // 单选：替换；多选：追加
        if (!state.detail.st_vote.multiple) {
          state.playerIds = [playerId];
        } else {
          if (!state.playerIds.includes(playerId)) {
            state.playerIds.push(playerId);
          }
        }
      } else {
        // 取消选择
        state.playerIds = state.playerIds.filter(id => id !== playerId);
      }

    } else if (ruleType === 1) {
      // 单分组模式：不能跨组，新组会替换旧组
      state.ruleMultiple= state.voteRule?.[groupId]?.multiple || 0
      if (multiple) {
        // 检查是否是新组（与当前已选不同组）
        const currentGroupId = Object.keys(state.groupIds)[0];
        if (currentGroupId && String(currentGroupId) !== String(groupId)) {
          // 切换到新组，清空旧组数据
          state.groupIds = { [groupId]: [playerId] };
        } else {
          // 同组内选择
          if (!state.groupIds[groupId]) {
            state.groupIds[groupId] = [];
          }

          const rule = state.voteRule?.[groupId];
          if (rule?.multiple === 0) {
            // 组内单选：替换
            state.groupIds[groupId] = [playerId];
          } else {
            // 组内多选：追加
            if (!state.groupIds[groupId].includes(playerId)) {
              state.groupIds[groupId].push(playerId);
            }
          }
        }
      } else {
        // 取消选择
        if (state.groupIds[groupId]) {
          state.groupIds[groupId] = state.groupIds[groupId].filter(id => id !== playerId);
          if (state.groupIds[groupId].length === 0) {
            delete state.groupIds[groupId];
          }
        }
      }

    } else if (ruleType === 2) {
      // 多分组模式：可以跨组，各组独立
      if (multiple) {
        if (!state.groupIds[groupId]) {
          state.groupIds[groupId] = [];
        }

        const rule = state.voteRule?.[groupId];
        if (rule?.multiple === 0) {
          // 该组单选：替换
          state.groupIds[groupId] = [playerId];
        } else {
          // 该组多选：追加
          if (!state.groupIds[groupId].includes(playerId)) {
            state.groupIds[groupId].push(playerId);
          }
        }
      } else {
        // 取消选择
        if (state.groupIds[groupId]) {
          state.groupIds[groupId] = state.groupIds[groupId].filter(id => id !== playerId);
          if (state.groupIds[groupId].length === 0) {
            delete state.groupIds[groupId];
          }
        }
      }
    }

    // 同步 playerIds（用于统一获取已选列表）
    if(ruleType != 0 ){
      state.playerIds = [...new Set(Object.values(state.groupIds).flat())];
    }
  },
  [CLEAR_PLAYER](state) {
    state.playerIds = []
  },
  [CLEAR_GROUP_PLAYER](state){
    state.groupIds = {}
    state.currentGroupId = 0
    state.realGroupId = 0
  },

  [WECHAT_TIP](state, showTip) {
    state.showTip = showTip
  },
  [VERIFY_CODE](state, showCode) {
    state.showCode = showCode
    if (!showCode && state.detail.st_vote.multiple == 0) {
      this.commit(CLEAR_PLAYER)
    }
  },
  [VOTE_AD](state, showVoteAd) {
    state.showVoteAd = showVoteAd
  },
  [COUNTDOWN_END](state) {
    state.detail.countdown = 0
  },
  [FOOTER_END](state) {
    state.detail.st_other.is_footer = 0
  },
  [UPDATE_TIP](state, tip) {
    state.updateTip = tip
  },
    [SHOW_POSTER](state, poster) {
    state.showPoster = poster
  },
 [SET_LAST_VOTE_PLAYER_ID](state, playerId) {
    state.lastVotePlayerId = playerId
  },
  [SET_LAST_VOTE_PLAYER_IDS](state, playerIds) {
    state.lastVotePlayerIds = playerIds
  },
}

const actions = {}

const getters = {
  activityId(state) {
    return state.id
  },
  color(state) {
    return state.detail.st_page.color
  },
  select(state) {
    return state.playerIds.length > 0
  },
  detail(state) {
    return {
      name: state.detail.name,
      start_time: state.detail.start_time,
      end_time: state.detail.end_time,
      status: state.detail.status,
      countdown: state.detail.countdown || 0,
      iframe: state.detail.iframe
    }
  },
  carousels(state) {
    return state.detail.carousels
  },
  playerCall(state) {
    return state.detail.st_other.player_call
  },
  playerUnit(state) {
    return state.detail.st_other.player_unit
  },
  buttonName(state) {
    return state.detail.st_other.button_name
  },
  isTips(state){
    return state.detail.st_other.is_tips
  },
  tips(state){
    return state.detail.st_other.tips
  },
  tipsTxt(state){
    return state.detail.st_other.tips_txt != null ? state.detail.st_other.tips_txt : '温馨提示'
  },
  pollUnit(state) {
    return state.detail.st_other.poll_unit
  },
  enrollOptions(state) {
    return state.detail.st_register
  },
  otherOptions(state) {
    return state.detail.st_other
  },
  pageOptions(state) {
    return state.detail.st_page
  },
  displayOptions(state) {
    let options = {}
    switch (state.to) {
      case 'intro':
        options = state.detail.st_display_intro
        break
      case 'vote':
        options = state.detail.st_display_vote
        break
      case 'rank':
        options = state.detail.st_display_ranking_list
        break
    }
    return options
  },
  playerOptions(state) {
    return state.detail.st_display_player
  },
  footerOptions(state) {
    return state.detail?.st_footer || null
  },
  voteOptions(state) {
    return state.detail?.st_vote || null
  },
  shareOptions(state) {
    return state.detail?.st_share || null
  }
}

export default { state, mutations, actions, getters }
